<template>
  <div class="preoject-wrapper d-flex">
    <div :class="{'drawer-tree-wrapper p-2': drawer.tree, 'drawer-tree-wrapper-hide': !drawer.tree ,'hideTree': drawer.treeHide, 'showTree': !drawer.treeHide }">

      <div class="drawer-pulltab" v-show="drawer.tree">
        <el-tooltip class="item" effect="dark" :content="drawer.tree ? 'ツリーを隠す' : 'ツリーを表示する'" placement="right" :disabled="!drawer.toolTip">
          <el-button size="medium" type="text" @click="toggleTree" class="w-100">
            <i class="fas text-primary" :class="[drawer.tree ? 'fa-caret-left' : 'fa-caret-right']"></i><br />
          </el-button>
        </el-tooltip>
      </div>
      <tree-list
        ref="treeList"
        :defaultProps="defaultProps"
        @clicked-node="onNodeSelect"
        @transfer="transferProc"
        @handleRightClick="handleRightClick"
        :project="project"
        :projectId="projectId"
        :class="{'fadeIn':!drawer.treeHide, 'fadeOut':drawer.treeHide}"
      ></tree-list>

      <div class="drawer-pulltab h-100" v-show="!drawer.tree">
        <el-tooltip class="item" effect="dark" content="ツリーを表示する" placement="right" :disabled="!drawer.toolTip">
          <el-button size="medium" type="text" @click="toggleTree" class="w-100 ">
            <i class="fas text-primary" :class="[drawer.tree ? 'fa-caret-left' : 'fa-caret-right']"></i><br />
          </el-button>
        </el-tooltip>
      </div>

    </div>
    <!-- <div v-if="nodeData && nodeData.type=='file'" class="w-100 h-100"> -->
      <!-- <img v-if="imageUrl" :src="imageUrl" />
      <vue-pdf-embed v-if="pdfUrl" :source="pdfUrl" /> -->
      <el-image
        v-if="imageUrl"
        class="position-absolute"
        ref="imgPreview"
        style="width: 1px; height: 1px"
        :src="imageUrl"
        :preview-src-list="[imageUrl]"
        :initial-index="4"
        @close="filePreview=false"
        fit="cover"
      />
      <el-dialog v-model="pdfUrl" v-if="pdfUrl">
        <!-- <div v-if="imageUrl" class="d-flex align-items-center justify-content-center" > -->
          <!-- <img w-full :src="dialogImageUrl" alt="Preview Image" /> -->
          <!-- <img v-if="imageUrl" :src="imageUrl" /> -->
        <!-- </div> -->

        <vue-pdf-embed v-if="pdfUrl" :source="pdfUrl" />
      </el-dialog>
    <!-- </div> -->

    <div class="main-view flex-fill ml-1 " v-if="true" style="overflow:hidden;position:relative;">
      <!-- 最近使用したファイル -->
      <recently v-if="activeView.recently && userInfo" :projectId="projectId" :userSub="userInfo.sub" @clicked-file="onNodeSelectRecently" />
      <!-- ファイルリスト -->
      <file-list v-if="activeView.fileList" :tenantId="tenantId" :projectId="projectId" :userSub="userInfo.sub" :nodeId="nodeId" :treePlace="selectedTreePlace" @clicked-file="onNodeSelectFileList" />
    <!-- <div class="main-view flex-fill ml-1 " v-if="true"> -->
      <!-- 図面表示 -->

      <div v-if="activeView.map" class="grid-area" :class="{'grid-area-half': drawer.placeListHalf, 'grid-area-list': drawer.placeListFull, 'grid-area-map': !drawer.placeListHalf && !drawer.placeListFull }" >
        <div class="top-area">
          <div style="position:absolute;left:50%;bottom:0;z-index:1000;">
            <div v-if="!drawer.placeListHalf && !drawer.placeListFull" class="my-box flex-fill pr-1">
              <el-button size="medium" class="bg-shadow1" @click="togglePlaceList">
                <i class="fas text-primary font-size-middle" :class="[drawer.placeListFull ? 'fa-angle-double-down' : 'fa-angle-double-up']"></i>
              </el-button>
            </div>
          </div>
          <!-- 地図、図面表示のビュー -->
          <leaflet-map
            :class="{'d-none': drawer.placeListFull}"
            :projectId="projectId" ref="map"
            :nodeId="nodeId"
            :fileType="fileType"
            @transfer="transferProc"
            @mapReload="mapReload"
            @unloadMap="unLoadMap"
            :noticePlaceData="mapArgs"
            :placeData="placeDataFromList"
            :treePlace="selectedTreePlace">
          </leaflet-map>
        </div>
        <div class="middle-area bg-white" style="position:relative;" v-if="drawer.placeListHalf || drawer.placeListFull">
          <div style="position:absolute;right:5px;top:5px;z-index:1000;" v-if="drawer.placeListFull">
            <el-button size="medium" circle @click="closePlaceList">
              <i class="fas fa-times"></i>
            </el-button>
          </div>
          <!-- 検査一覧全体表示のボタン -->
          <div style="position:absolute;left:50%;top:0;z-index:1000;">
            <!-- 結果一覧を全体表示 -->
            <el-button size="medium" class="bg-shadow1" @click="togglePlaceList">
              <i class="fas text-primary font-size-middle" :class="[drawer.placeListFull ? 'fa-angle-double-down' : 'fa-angle-double-up']"></i>
            </el-button>
            <!-- 結果一覧を非表示に（図面を全体表示） -->
            <el-button size="medium" class="bg-shadow1" @click="closePlaceList" v-if="!drawer.placeListFull">
              <i class="fas text-primary font-size-middle fa-angle-double-down shadow-sm"></i>
            </el-button>
          </div>
        </div>
        <!-- データ保存時に検査箇所一覧画面の半分表示を防ぐためoverflow: hiddenを指定 -->
        <div class="bottom-area bg-white" style="overflow: hidden;">
          <div class="h-100">
            <inspect-place-list :placeListOnly="false" :projectId="projectId" :nodeId="nodeId" :nodeType="nodeType" @onClickPlaceListItem="showPlaceListItem" :treePlace="selectedTreePlace" :isFullSize="drawer.placeListFull"></inspect-place-list>
          </div>
        </div>
      </div>


      <!-- 検査マスタ一覧 -->
      <inspect-master-list v-if="activeView.masterList" @transfer="transferProc" :transferArgs="inspectMasterListArgs" :projectId="projectId"></inspect-master-list>
      <!-- 検査マスタ編集 -->
      <inspect-master-edit v-if="activeView.masterEdit" @transfer="transferProc" :transferArgs="inspectMasterEditArgs" :projectId="projectId"></inspect-master-edit>
      <!-- ファイルリスト表示 -->
      <file-list-view v-if="false && fileType===0 || fileListArgs!=null" :dirList="dirList" @clicked-file="onFileSelect" @transfer="transferProc" :transferArgs="fileListArgs"></file-list-view>
      <!-- 検査箇所一覧 -->
      <inspect-place-list ref="placelist" :placeListOnly="true" v-if="fileType===4" :projectId="projectId" :nodeId="nodeId" :nodeType="nodeType" @transfer="transferProc" :treePlace="selectedTreePlace" @onClickPlaceListItem="showPlaceListItem" @addNewPlace="addNewPlaceOnPlaceList"></inspect-place-list>
    </div>

    <!-- 検査箇所を表示するモーダル -->
    <modal :show="drawer.place" v-if="drawer.place" size="lg" body-classes="p-0" style="z-index:1060;" >
      <inspect-place @transfer="transferProc" @addComplete="addPlaceComplete" @editComplete="editPlaceComplete" @cancelPlace="cancelPlace" :editPlaceId="editPlaceId" @inspectPlaceDeleteComplete="inspectPlaceDeleteComplete" :projectId="projectId" :project="project" :nodeId="nodeId" :addPlaceData="addPlaceData" :treePlace="selectedTreePlace"></inspect-place>
    </modal>

    <!-- コンテキストメニュー -->
    <card
      id="contextMenu"
      ref="contextMenu"
      class="dropdown-menu tree-context-menu context-menu"
      :noBody=true
      :style="context_position"
      style="cursor: pointer;"
      v-show="treeContextShow">
      <!-- フォルダ追加 -->
      <a v-show="tree.addFolder" class="dropdown-item pt-1 pb-1" @click="handlerMenuAddFolder" ><i class="fa fa-folder-plus text-primary"></i>{{$t('ツリー.1')}}</a>
      <div v-show="tree.div1" class="dropdown-divider"></div>
      <!-- フォーム追加 -->
      <a v-show="tree.addForm" class="dropdown-item pt-1 pb-1" @click="handlerMenuAddInspect"><i class="fa fa-notes-medical text-primary"></i>{{$t('ツリー.2')}}</a>
      <!-- フォーム編集 -->
      <a v-show="tree.editForm" class="dropdown-item pt-1 pb-1" @click="handlerMenuBackImageSetting"><i class="fa fa-tools text-primary"></i>{{$t('ツリー.4')}}</a>
      <!-- ファイル追加 -->
      <a v-show="tree.addFile" class="dropdown-item pt-1 pb-1" @click="handlerAddfile"><i class="far fa-file-image text-primary"></i>{{$t('ツリー.3')}}</a>
      <div v-show="tree.div2" class="dropdown-divider"></div>
      <!-- 名前変更 -->
      <a v-show="tree.rename" class="dropdown-item pt-1 pb-1" @click="handlerMenuRename"><i class="el-icon-edit text-primary"></i>{{$t('ツリー.5')}}</a>
      <div v-show="tree.div3" class="dropdown-divider"></div>
      <!-- 削除 -->
      <a v-show="tree.delete" class="dropdown-item pt-1 pb-1" @click="handlerMenuDeleteNode"><i class="fa fa-trash-alt text-primary"></i>{{$t('ツリー.6')}}</a>
    </card>
  </div>
</template>

<style scoped>
  /** このVueだけのスタイル */
  .preoject-wrapper {
    border: 0px solid red;
    width:100% ;
    height:100%;
    position: relative;

  }

  .main-view {
    border:0x solid gray;
    /* width:calc(100%-30px); */
    height:100%;
    /* margin-left: 30px; */
    /* position: relative; */
    transition: all 300ms 0s ease;
  }
  .drawer-pulltab{
    position:absolute;
    border: 0px solid green;
    z-index: 1041;
    right:0px;
    width:30px;
    top: 0px;
    height:50px;
    /* border-radius: 0px 5px 5px 0px; */
    /* background-color: white; */
    /* box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, .25); */
  }

  .el-button {
    border-style: none;
  }

  .tree-context-menu {
    position: fixed;
    z-index: 1050;
  }

  .context-menu {
    box-shadow:  0 50px 100px rgb(50 50 93 / 10%), 0 15px 35px rgb(50 50 93 / 15%), 0 5px 15px rgb(0 0 0 / 10%) !important;
  }
</style>
<style>
  /** 全体に影響するスタイル */
/* .right-enter-active,
.right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 500ms cubic-bezier(.29,.7,.63,1.02) 0ms;

}
.right-enter,
.right-leave-to {
  transform: translateX(100%) translateX(0px);
  transition: transform 400ms cubic-bezier(.29,.7,.63,1.02) 0ms;
} */
.grid-area {
  display: grid;
  height: 100%;
}
.grid-area-map {

  grid-template-columns: 100%;  /* 横幅いっぱいに1列用意 */
  grid-template-rows: 1fr 0px 0px;   /* gridの割合が8:2になるよう2行用意 */
}

.grid-area-half {

  grid-template-columns: 100%;  /* 横幅いっぱいに1列用意 */
  grid-template-rows: 45% 5% 50%;  /* gridの割合が8:2になるよう2行用意 */
}

.grid-area-list {

  grid-template-columns: 100%;  /* 横幅いっぱいに1列用意 */
  grid-template-rows: 0px 50px 1fr;  /* gridの割合が8:2になるよう2行用意 */
}

.top-area {
  grid-row: 1;
  grid-column: 1;
}
.middle-area {
  grid-row: 2;
  grid-column: 1;
}
.bottom-area {
  grid-row: 3;
  grid-column: 1;
}

.hideTree {
  animation-name: hideTreeAnime;
  animation-duration:0.4s;
  animation-fill-mode:forwards;
  width:20%;
  min-width: 250px;
  opacity: 1;
}
@keyframes hideTreeAnime {
  from {
    width:20%;
    min-width: 250px;
    opacity: 1;
  }
  to {
    width:30px;
    min-width: 30px;
    opacity: 1;
  }
}
.timing-ease-in{
  animation-timing-function:ease-in;
}
.timing-ease-out{
  animation-timing-function:ease-out;
}
.showTree {
  animation-name: showTreeAnime;
  animation-duration:0.4s;
  animation-fill-mode:forwards;
  width:30px;
  min-width: 30px;
  opacity: 0;
}
@keyframes showTreeAnime {
  from {
    width:30px;
    min-width: 30px;
    opacity: 0;
  }
  to {
    width:20%;
    min-width: 250px;
    opacity: 1;
  }
}
.fadeIn50 {
  animation-name: fadeInAnime;
  animation-duration:0.3s;
  animation-fill-mode:forwards;
  animation-timing-function:ease-in;
  opacity: 0.5;
}
@keyframes fadeIn50Anime {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeInAnime;
  animation-duration:0.3s;
  animation-fill-mode:forwards;
  animation-timing-function:ease-in;
  opacity: 0;
}
@keyframes fadeInAnime {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeOut {
  animation-name: fadeOutAnime;
  animation-duration:0.3s;
  animation-fill-mode:forwards;
  animation-timing-function:ease-out;
  opacity: 1;
}
@keyframes fadeOutAnime {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.showMap {
  animation-name: showMapAnime;
  animation-duration:0.4s;
  animation-fill-mode:forwards;
  height:40%;
  min-height: 30px;
  opacity: 0;
}
@keyframes showMapAnime {
  from {
    height:40%;
    min-height: 30px;
    opacity: 0;
  }
  to {
    height:100%;
    min-height: 250px;
    opacity: 1;
  }
}
.hideMap {
  animation-name: hideMapAnime;
  animation-duration:0.4s;
  animation-fill-mode:forwards;
  height:100%;
  min-height: 250px;
  opacity: 1;
}
@keyframes hideMapAnime {
  from {
    height:100%;
    min-height: 250px;
    opacity: 1;
  }
  to {
    height:40%;
    min-width: 30px;
    opacity: 1;
  }
}

.showPlaceList {
  animation-name: showPlaceListAnime;
  animation-duration:0.4s;
  animation-fill-mode:forwards;
  height:30px;
  min-height: 30px;
  opacity: 0;
}
@keyframes showPlaceListAnime {
  from {
    height:30px;
    min-height: 30px;
    opacity: 0;
  }
  to {
    height:70%;
    min-height: 250px;
    opacity: 1;
  }
}
.hidePlaceList {
  animation-name: hidePlaceListAnime;
  animation-duration:0.4s;
  animation-fill-mode:forwards;
  height:60vh;
  min-height: 250px;
  opacity: 1;
}
@keyframes hidePlaceListAnime {
  from {
    height:60vh;
    min-height: 250px;
    opacity: 1;
  }
  to {
    height:30px;
    min-width: 30px;
    opacity: 1;
  }
}
.left-leave-active,
.left-enter-active  {
  transform: translate(0, 0);
  transition: transform 400ms ;/*liner cubic-bezier(0, 0, 0.2, 1) 0ms;*/
}
.left-enter-from, .left-leave-to {
  transform: translateX(-100%) translateX(0);
}
/* .left-enter-to, .left-leave-from {
  transform: translateX(0) translateX(0);
} */
.drawer-tree-wrapper {
  position: relative;
  z-index: 1040;
  /* top: 0; */
  /* left: 0; */
  /* width: 20%; */
  /* height: 100%;  100%ではツリー展開時に地図表示エリアが拡大されるのでvh指定に変更*/
  height: calc(100vh - 48px);
  background-color: rgba(255,255,255,1);
  border-left:0px solid rgba(150,150,150,0.9);
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, .25);
  transition: all 300ms 0s ease;
}
.drawer-tree-wrapper-hide{
  position: relative;
  z-index: 1039;
  /* top: 0; */
  /* left: 0; */
  width: 30px;
  /* height: 100%;  100%ではツリー展開時に地図表示エリアが拡大されるのでvh指定に変更*/
  height: calc(100vh - 48px);
  background-color: rgba(255,255,255,1);
  border-left:0px solid rgba(150,150,150,0.9);
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, .25);
}
.drawer-placeList {
  border-top: 1px solid silver;
}
.drawer-placeList-wrapper {
  position: relative;
  z-index: 1040;
  /* top: 0; */
  /* left: 0; */
  /* width: 20%; */
  height: 60vh;
  background-color: rgba(255,255,255,1);
  border-left:0px solid rgba(150,150,150,0.9);
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, .25);
  transition: all 300ms 0s ease;
}
.drawer-placeList-wrapper-hide{
  position: relative;
  z-index: 1039;
  /* top: 0; */
  /* left: 0; */
  width: 100%;
  height: 30px;
  background-color: rgba(255,255,255,1);
  border-left:0px solid rgba(150,150,150,0.9);
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, .25);
}
.drawer-menu {
  padding: 24px;
}
.tree-wrap {
  max-height:calc(100% - 15px);
  height:calc(100% - 15px) !important;
  border:0px solid red;
  overflow:auto;
}
.tree-wrap-hide {
  max-height:calc(100% - 15px);
  height:calc(100% - 15px) !important;
  border:0px solid red;
  overflow-y:hidden;
}

</style>
<script>
import appLog from "@/appUtils/AppLog"
import ProjectModel from "@/appModel/project/ProjectModel"
import TreeItemModel from "@/appModel/Tree/TreeItemModel"
import TreeList from "@/appViews/components/FileView/TreeList";
import LeafletMap from "@/appViews/Map/Map.vue";
import InspectPlaceModel from "@/appModel/InspectPlace/InspectPlaceModel"
import BackImageModel from "../../appModel/BackImage/BackImageModel";
import FilePreview from "@/appViews/components/FileView/FilePreview";
import FileListView from "@/appViews/components/FileView/FileListView";

import InspectMasterList from "@/appViews/InspectMaster/InspectMasterList.vue"
import InspectMasterEdit from "@/appViews/InspectMaster/InspectMasterEdit.vue"
import InspectPlace from "@/appViews/InspectPlace/InspectPlace.vue"
import InspectPlaceList from "@/appViews/InspectPlace/InspectPlaceList.vue"
import Recently from "@/appViews/Projects/Recently"

import FileList from "@/appViews/Projects/FileList";

import Modal from "@/components/Modal";
import TenantStorage from "@/appUtils/TenantStorage"
import path from 'path'
import VuePdfEmbed from 'vue-pdf-embed'
import RecentlyViewModel from "@/appViews/Projects/ViewModel/RecentlyViewModel"
import { useToast } from "vue-toastification";

// import DateUtil from "@/appUtils/DateUtil"
import UserInfo from "@/appUtils/UserInfo"

export default {
  components: {
    TreeList,
    LeafletMap,
    FileList,
    FileListView,
    InspectMasterList,
    InspectMasterEdit,
    InspectPlace,
    InspectPlaceList,
    Modal,
    Recently,
    VuePdfEmbed
  },
  data() {
    return {
      drawer: {
        tree: true,
        treeShow: true,
        treeHide: false,
        place: false,
        toolTip: true,
        placeList: false,
        placeListHalf: false,
        placeListFull: false

      },
      userInfo: null,
      activeView: {
        map: false,
        masterList: false,
        masterEdit: false,
        file: false,
        fileList: false,
        recently: true
      },
      stab: {
        // 仮データ
        projectId: "3fw34B7dLk5idTmdtoYxyj",
        project: {},
        nodeId: "8M4VLRJ5qHnK4CmpP4ksE5",
        fileType: 1
      },
      // カレントディレクトリのパンくず表示用不要か？
      dirList: [],
      fileInfo: null,
      fileAttributes: [],
      fileType: 3,
      mapTitle: "",
      nodeData: {},
      // projectId: "",
      nodeId: "",
      nodeType: "",
      fileListArgs: null,
      mapArgs: null,
      mapTileArgs: null,
      inspectMasterEditArgs: null,
      inspectMasterListArgs: {},
      inspectPlaceArgs: null,
      placeId: null,
      addPlaceData: null,
      editPlaceId: null,
      imageUrl: null,
      pdfUrl: null,
      tenantId: null,
      tenantStorage: null,
      recentlyViewModel: null,
      placeDataFromList: null,
      selectedTreePlace: "",
      filePreview: false,
      toastId: "ProjectView",
      context_position: {
        left: 0,
        top: 0
      },
      treeContextShow: false,
      tree: {
        addFolder: false,
        addForm: false,
        editForm: false,
        addFile: false,
        rename: false,
        delete: false,
        div1: false,
        div2: false,
        div3: false
      },
      height: window.innerHeight,
    };
  },
  props: {
    /**
     * TODO:不要なら消す
     */
    defaultProps: Object,
    /**
     * プロジェクトID
     */
    projectId: String,
    /**
     * プロジェクト
     */
    project: Object,

    p_login_user_sub: {
      type: String,
      default: "",
    },
    p_login_tenant: {
      type: String,
      default: "",
    },
    p_login_usertype: {
      type: String,
      default: "",
    },
    p_project_id: {
      type: String,
      default: "",
    }
  },
  computed: {
    vuename() {
      return this.$route.name
    }
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    //インスタンスが生成され､且つデータが初期化された後
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    appLog.infoLog(`${this.vuename}`, `Start ${this.vuename}`)
    this.init().then(() =>{

    })

    // ページ表示時に実行
    this.handleResize();
    window.addEventListener('resize', this.handleResize)
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
    window.removeEventListener('resize', this.handleResize)
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      console.log("init")
      console.log(`ProjectView: ${JSON.stringify(this.project)}`)

      // this.userInfo = await UserInfo.getUserInfo()
      this.userInfo = await this.$root.getUserInfo()
      this.tenantId = this.userInfo.group
      this.recentlyViewModel = new RecentlyViewModel(this.projectId, this.userInfo.sub, this.userInfo.group)

      // const tenantStore = this.$store.state.tenant
      // this.tenantId = tenantStore.id
      this.tenantStorage = new TenantStorage(this.tenantId)

      //通知からの遷移でlinkedIdがあれば、検査箇所を表示させた状態にする
      let noticeStore = this.$store.state.notice

      if (noticeStore.linkedId) {
        // linkedIdには検査箇所のskがセットされている前提
        this.clearSelectInfo()

        this.$nextTick(async function() {
          // UI更新処理が走ってからMapを表示
          this.drawer.tree = false
          // 検査箇所のskを分解してノードID取得
          this.nodeId = noticeStore.linkedId.split("#")[2]

          // ノード情報を取得
          let treeSk = TreeItemModel.createSk(this.projectId, this.nodeId)
          let treeItem = await TreeItemModel.get(treeSk, this.tenantId)

          // 背景図設定をDBから取得
          let backImageSk = BackImageModel.createSk(this.projectId, this.nodeId)
          let backImage = await BackImageModel.getBackImage({sk: backImageSk}, this.tenantId)

          switch (treeItem.treeItem.type) {
          case "backimage":{
            // 背景図設定がある
            this.inspectPlaceArgs = {}
            this.fileType = 1
            break
          }
          case "map": {
            // 背景図設定なしの場合は地図
            this.fileType = 2
            break
          }
          case "nobackimage": {
            this.fileType = 4
            break
          }
          default: {
            break
          }
          }

          // if (backImage) {
          //   // 背景図設定がある
          //   this.inspectPlaceArgs = {}
          //   this.fileType=1
          // } else {
          //   // 背景図設定なしの場合は地図
          //   this.fileType=2
          // }

          // 検査箇所情報をDBから取得
          let place = await InspectPlaceModel.getInspectPlace({sk: noticeStore.linkedId}, this.tenantId)

          if (this.fileType == 1 || this.fileType == 2) {
            // 図面へのパラメータに検査箇所情報をそのまま渡す
            this.nodeType = treeItem.treeItem.type
            this.mapArgs = place;

            // 地図表示する
            this.activeView = {
              map: true,
              masterList: false,
              masterEdit: false,
              file: false,
              fileList: false,
              recently: false
            }

            this.dirList = null
          } else if (this.fileType == 4) {
            // this.selectedTreePlace = data.treePlace
            this.nodeType = treeItem.treeItem.type
            this.mapArgs = {}
            this.drawer.place = false
            this.addPlaceData = null
            this.fileType = 4;
            this.dirList = null
          }
        })
      }

      // テナント有効期限、ユーザーのログインチェック
      if (!await this.$root.validateSession()) {
        return
      }
    },

    toggleTree() {
      // ツリーのコンテキストメニューを消す
      this.$refs.treeList.onleftclick()
      this.treeContextShow = false
      // 展開中にツールチップが表示されるのを抑止する
      this.drawer.toolTip = false
      setTimeout(function() {
        this.drawer.toolTip = true
      }.bind(this), 500)

      // ドロワー開閉状況に応じてプロパティを更新してアニメーションさせる
      if (!this.drawer.tree) {
        // ドロワが閉じているとき

        // 開く
        this.drawer.tree = true
        this.$nextTick(function(){
          this.drawer.treeHide = false
        }.bind(this))
      } else {
        // ドロワが開いているとき

        // CSSアニメーション制御用のフラグ
        this.drawer.treeHide = true
        setTimeout(function() {
          // CSS定義のアニメーション後にドロワを閉じる
          this.drawer.tree = false
        }.bind(this), 400)
      }
    },

    closePlaceList() {
      this.drawer.placeListHalf = false
      this.drawer.placeListFull = false
      this.$nextTick(function() {
        this.$refs.map.refreshLastbound()
      }.bind(this))
    },

    togglePlaceList() {
      if (!this.drawer.placeListHalf && !this.drawer.placeListFull) {
        // 検査リストが半分でもフルでもない場合、半分表示にする
        this.drawer.placeListHalf = true
      } else {
        // 半分表示状態か全体表示状態の場合は全体表示のフラグ切り替え
        if (this.drawer.placeListHalf) {
          this.drawer.placeListFull = true
          this.drawer.placeListHalf = false
        } else {
          this.drawer.placeListFull = false
          this.drawer.placeListHalf = true
        }
      }

      this.$nextTick(function() {
        this.$refs.map.refreshLastbound()
      }.bind(this))

      // ドロワー開閉状況に応じてプロパティを更新してアニメーションさせる
      // if (!this.drawer.placeList) {
      //   // ドロワが閉じているとき

      //   // 開く
      //   this.drawer.placeList = true
      //   this.$nextTick(function(){
      //     this.drawer.placeListHalf = false
      //   }.bind(this))
      // } else {
      //   // ドロワが開いているとき

      //   // CSSアニメーション制御用のフラグ
      //   this.drawer.placeListHalf = true
      //   setTimeout(function() {
      //     // CSS定義のアニメーション後にドロワを閉じる
      //     this.drawer.placeList = false
      //   }.bind(this), 400)
      // }
    },

    /**
     * 図面のリロード
     */
    mapReload() {
      // 必要なパラメータはプロパティにセット済みのため、表示のオンオフのみを行う
      // typeだけ対比
      const currentType = this.fileType

      // 検査箇所一覧⇒Map
      this.clearSelectInfo()
      this.fileType = currentType

      this.$nextTick(function() {
        // 地図表示する
        this.activeView = {
          map: true,
          masterList: false,
          masterEdit: false,
          file: false,
          fileList: false,
          recently: false
        }
      }.bind(this))
    },

    /**
     * 検査箇所一覧からの検査箇所追加
     */
    async addNewPlaceOnPlaceList(params) {
      if (params.newPlaceData){
        this.editPlaceId = null
        this.addPlaceData = null
        this.mapArgs = {}
        //this.placeId = params.newPlaceData.id
        this.addPlaceData = params.newPlaceData.dbData
        this.drawer.place = !this.drawer.place;
      }
    },

    /**
     * 検査箇所追加完了時のハンドラ
     */
    async addPlaceComplete(params) {
      this.mapArgs = {}
      this.drawer.place = false
      this.addPlaceData = null

      if (this.fileType == 4) {
        // 背景図なし
        this.$refs.placelist.reload()
      } else {
        // 図面
        this.$refs.map.addPoi(params.values)
        this.$refs.map.reload()
      }
    },

    /**
     * 検査箇所編集完了時のハンドラ
     */
    async editPlaceComplete() {
      this.mapArgs = {}
      this.drawer.place = false
      this.addPlaceData = null

      // this.$refs.map.addPoi(params.values)
      if (this.fileType == 4) {
        // 背景図なし
        this.$refs.placelist.reload()
      } else {
        // 図面
        this.$refs.map.reload()
      }
    },

    /**
     * 検査箇所削除完了時のハンドラ
     */
    inspectPlaceDeleteComplete() {
      this.mapArgs = {}
      this.drawer.place = false
      this.addPlaceData = null

      this.$refs.map.reload()
    },

    /**
     * 検査箇所モーダルキャンセル時のハンドラ
     */
    async cancelPlace() {
      this.mapArgs = {}
      this.drawer.place = false
      this.addPlaceData = null
    },

    transferProc(params) {
      // {sendTo:[router.pushに渡すJSON],key:string(ex:inspectMasterListArgs),values:{}}

      console.log(`transferProc:${JSON.stringify(params, null, "\t")}`)

      if (params.sendTo) {
        // ルーティング先が指定されている場合
        this.clearSelectInfo()
        this.$router.push(params.sendTo)
        return
      } else {
        //this.clearSelectInfo()
        if (params) {
          switch (params.key) {
          case "inspectPlaceArgs":
            this.editPlaceId = null
            this.addPlaceData = null

            if (params.newPlaceData){
              this.mapArgs = {}
              //this.placeId = params.newPlaceData.id
              this.addPlaceData = params.newPlaceData.dbData
              this.drawer.place = !this.drawer.place;
              console.log(`inspectPlaceArgs open ${JSON.stringify(this.addPlaceData)}`)
            } else if (params.selectPlaceData) {
              this.mapArgs = {}
              this.editPlaceId = params.selectPlaceData.id
              this.drawer.place = !this.drawer.place;
              console.log(`inspectPlaceArgs open ${params.selectPlaceData.id}`)
            } else if (params.values) {
              this.mapArgs = {}
              this.editPlaceId = params.values.id
              this.drawer.place = !this.drawer.place;
              console.log(`inspectPlaceArgs open ${params.values.id}`)
            }
            break
          case "inspectPlaceAddComplete":
            // this.mapArgs = {}
            // this.drawer.place = false
            // this.addPlaceData = null
            // if (this.fileType == 4) {
            //   // 背景図なし
            // } else {
            //   // 図面
            //   this.$refs.map.addPoi(params.values)
            // }
            break
          case "inspectPlaceEditComplete":
            // this.mapArgs = {}
            // this.drawer.place = false
            // this.addPlaceData = null

            // // this.$refs.map.addPoi(params.values)
            // this.$refs.map.reload()
            break
          case "inspectPlaceCancel":
            // this.mapArgs = {}
            // this.drawer.place = false
            // this.addPlaceData = null
            break
          case "inspectPlaceDeleteComplete":
            this.mapArgs = {}
            this.drawer.place = false
            this.addPlaceData = null

            this.$refs.map.reload()
            break
          case "inspectPlaceListArgs":
            // ノードID
            this.clearSelectInfo()

            // UI更新処理が走ってから検査箇所一覧を表示
            this.$nextTick(function() {
              this.nodeData = params.values
              console.log(JSON.stringify(this.nodeData, null, "\t"))
              this.nodeId = this.nodeData.id
              this.nodeType = this.nodeData.type
              this.mapArgs = {}
              this.drawer.place = false
              this.addPlaceData = null
              this.fileType = 4;
            }.bind(this))

            break
          case "mapArgs":
            // 検査箇所一覧⇒Map
            this.clearSelectInfo()

            // UI更新処理が走ってからMapを表示
            this.drawer.tree = false

            this.$nextTick(function() {
              this.dirList = null
              console.log(`mapArgs ${JSON.stringify(params.values)}`)
              this.mapArgs = params.values;

              // ノードID
              this.nodeId = params.values.nodeId;
              const nodeType = params.values.nodeType;

              // 地図表示する
              this.activeView = {
                map: true,
                masterList: false,
                masterEdit: false,
                file: false,
                fileList: false,
                recently: false
              }

              this.dirList = null

              switch (nodeType) {
              case "backimage":
                this.inspectPlaceArgs = {}
                this.fileType=1
                break
              case "map":
                this.fileType=2
                break
              }
            }.bind(this))
            break
          default:
            this.clearSelectInfo()
            this.activeView = {
              map: false,
              masterList: params.key == "inspectMasterListArgs",
              masterEdit: params.key == "inspectMasterEditArgs",
              file: false,
              fileList: false,
              recently: true
            }

            this[params.key] = params.values
            console.log(`${params.key}`)
            break
          }
        }
      }
    },

    clearSelectInfo() {
      this.fileType = -1
      this.fileListArgs = null
      this.mapArgs = null
      this.mapTileArgs = null
      this.inspectMasterEditArgs = null
      this.inspectMasterListArgs = null
      this.inspectPlaceArgs = null
      this.drawer.place = false
      this.placeId = null

      this.activeView = {
        map: false,
        masterList: false,
        masterEdit: false,
        file: false,
        fileList: false,
        recently: false
      }
    },

    /**
     * 最近使用したファイルから選択された場合
     */
    onNodeSelectRecently(data) {
      const nodeData = {
        "label": data.treeItem.label,
        "id": data.treeItem.id,
        "type": data.treeItem.type,
        "path": data.treeItem.path,
        "fileSize": data.treeItem.fileSize,
        "sk": data.sk,
        "lsiInt1": data.lsiInt1,
        "lsiStr1": data.lstStr1,
        "treePlace": data.treePlace
      }

      // console.log(`onNodeSelectRecently ${JSON.stringify(nodeData)}`)
      this.onNodeSelect(nodeData, false)
    },

    onNodeSelectFileList(data) {
      const nodeData = {
        "label": data.treeItem.label,
        "id": data.treeItem.id,
        "type": data.treeItem.type,
        "path": data.treeItem.path,
        "fileSize": data.treeItem.fileSize,
        "sk": data.sk,
        "lsiInt1": data.lsiInt1,
        "lsiStr1": data.lstStr1,
        "treePlace": data.treePlace
      }
      // console.log(`onNodeSelectRecently ${JSON.stringify(nodeData)}`)
      this.onNodeSelect(nodeData, true)
    },

    showPlaceListItem(row) {
      // 検査箇所一覧⇒Map
      // this.clearSelectInfo()
      // UI更新処理が走ってからMapを表示
      console.log(`showPlaceListItem ${JSON.stringify(row)}`)
      this.mapArgs = {}
      this.editPlaceId = row.inspectPlace.placeId
      this.drawer.place = !this.drawer.place;
      // this.placeDataFromList = row

      if (this.fileType===4) {
        // 図面なしの場合
      } else {
        // 図面ありの場合は図面上でハイライトする
        this.$refs.map.placeHighLight(row)
      }
    },

    /**
     * ツリーノード選択時の処理
     */
    async onNodeSelect(data, addRecentryFlg = true) {
      console.log(`onNodeSelectRecently `)

      try {
        // メニュー非表示
        this.treeContextShow = false
        // プロジェクトID

        // ノードID
        this.nodeData = data
        // console.log(JSON.stringify(this.nodeData, null, "\t"))

        // ファイル選択時以外にノードIDを保持
        // this.nodeId = this.nodeData.id
        this.imageUrl = null
        this.pdfUrl = null
        this.filePreview = false

        // ファイル選択時以外はビュー表示をクリアする、ノードIDを保持
        if (data.type != "file"){
          this.clearSelectInfo()

          this.nodeId = this.nodeData.id
        }

        // 選択ノードがツリールートのプロジェクト名以外、かつフラグがtrueである場合は最近使用したファイルとして登録
        if (data.type != "project" && addRecentryFlg) {
          // 最近使用したファイルを登録する
          console.log(`nodeData.sk:${this.nodeData.sk}, treePlace:${this.nodeData.treePlace}, tenantId:${this.tenantId}`)
          await this.recentlyViewModel.addRecentlyfile(this.nodeData.sk, this.nodeData.treePlace, this.tenantId)
        }

        // const _this = this
        console.log(data.type)
        this.$nextTick(function() {
          switch (data.type) {
          case "folder":
            // this.drawer.tree = false
            // this.toggleTree()
            this.fileType=0
            // this.fileList = data.fileList
            this.dirList = data.dirList
            this.nodeId = this.nodeData.id
            this.selectedTreePlace = data.treePlace
            this.activeView = {
              map: false,
              masterList: false,
              masterEdit: false,
              file: false,
              fileList: true,
              recently: false
            }
            break
          case "backimage":
            // this.drawer.tree = false
            this.toggleTree()
            this.fileType=1
            //this.mapTitle = data.label
            // this.fileList = null
            this.dirList = null
            this.selectedTreePlace = data.treePlace

            this.inspectPlaceArgs = {}
            this.activeView = {
              map: true,
              masterList: false,
              masterEdit: false,
              file: false,
              fileList: false
            }
            // TODO: 動作確認用で固定値
            // this.placeId = "kruaXG7bbCGVWowrDviKWW"
            break
          case "map":
            // this.drawer.tree = false
            this.toggleTree()
            // TODO:地図表示する
            this.activeView = {
              map: true,
              masterList: false,
              masterEdit: false,
              file: false,
              fileList: false
            }
            this.selectedTreePlace = data.treePlace

            this.fileType=2
            this.dirList = null
            break
          case "nobackimage":
            this.selectedTreePlace = data.treePlace
            this.nodeId = this.nodeData.id
            this.nodeType = this.nodeData.type
            this.mapArgs = {}
            this.drawer.place = false
            this.addPlaceData = null
            this.fileType = 4;
            break;
          case "project":
            // this.fileType = 3
            // this.dirList = null
            // this.inspectMasterListArgs = {}
            this.activeView = {
              map: false,
              masterList: false,
              masterEdit: false,
              file: false,
              fileList: false,
              recently: true
            }
            break
          case "inspectMaster":
            this.drawer.tree = false
            this.fileType = 3
            this.dirList = null
            this.inspectMasterListArgs = {}
            this.activeView = {
              map: false,
              masterList: true,
              masterEdit: false,
              file: false,
              fileList: false,
              recentry: false
            }
            break
          case "file":{
            this.selectedTreePlace = data.treePlace
            console.log("file")
            let s3Key = this.nodeData.path
            let ext = path.extname(s3Key).toLowerCase()
            this.filePreview = true
            // // 最近使用したファイルに追加しない場合のときは
            // // ビュー表示を変更しないようにする
            if (!addRecentryFlg) {
              this.activeView.recently = !addRecentryFlg
            }

            // ※暫定処理
            if (ext == ".pdf") {
              this.tenantStorage.get(s3Key).then(function(result) {
                this.pdfUrl = result.toBase64()
              }.bind(this))
            } else {
              this.tenantStorage.get(s3Key).then(function(result) {
                this.imageUrl = result.toBase64()
                this.$nextTick(function(){
                  this.$refs.imgPreview.clickHandler()
                }.bind(this))

              }.bind(this))
            }
            //
            break
          }
          default:
            this.fileType=-1
            break
          }
        }.bind(this))
      } catch (e) {
        console.log(e);
        this.runToast(`ツリー選択時にエラーが発生しました。`, "error")
      }
    },

    onFileSelect(data) {

      this.fileInfo = {
        title: data.title,
      }
      this.fileAttributes = [
        {name: "type", value: data.type},
        {name: "size", value: data.size},
        {name: "createDate", value: data.createDate}
      ]

    },

    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },

    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    },

    /**
     * 図面表示抜けてプロジェクトノード選択状態にする
     */
    async unLoadMap() {
      this.$refs.treeList.setInitnode(true)
      await this.$refs.treeList.loadProjectTreeData()
    },

    handleRightClick(data, isSameNode, e) {

      // 表示制御
      this.isProject = false;
      this.tree = {
        addFolder: false,
        addForm: false,
        editForm: false,
        addFile: false,
        rename: false,
        delete: false,
        div1: false,
        div2: false,
        div3: false
      }

      // 同一ノード右クリックかつメニューが表示中の場合はメニューを閉じる
      if (isSameNode && this.treeContextShow){
        this.treeContextShow = false
        return
      }

      switch (data.type.toLowerCase()) {
      case "backimage":
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: true,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: true
        }
        this.isBackImage = true;
        this.isMap = false;
        break;
      case "map":
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: true,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: true
        }
        this.isBackImage = true;
        this.isMap = true;
        break;
      case "nobackimage":
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: true,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: true
        }
        this.isBackImage = true;
        this.isMap = true;
        break;
      case "inspectmaster":
        // 検査マスタは右クリック無し

        return
      case "project":
        this.isProject = true;
        this.tree = {
          addFolder: true,
          addForm: true,
          editForm: false,
          addFile: false,
          rename: false,
          delete: false,
          div1: true,
          div2: false,
          div3: false
        }
        break;
      case "folder":{
        let addFolderFlag = data.lsiInt1 < 4
        this.tree = {
          addFolder: addFolderFlag,
          addForm: true,
          editForm: false,
          addFile: true,
          rename: true,
          delete: true,
          div1: addFolderFlag,
          div2: true,
          div3: true
        }
        this.isBackImage = false;
        this.isMap = false;
        this.isProject = false;

        break;
      }

      case "file":{
        this.tree = {
          addFolder: false,
          addForm: false,
          editForm: false,
          addFile: false,
          rename: false,
          delete: true,
          div1: false,
          div2: false,
          div3: false
        }
        this.isBackImage = false;
        this.isMap = false;
        this.isProject = false;
        break;
      }
      default:
        this.treeContextShow = false
        break;
      }

      if (data.depthLv >= this.treeDepthLvLimit) {
        // 階層上限超え
        this.isDepthLvLimit = true;
      } else {
        this.isDepthLvLimit = false;
      }

      // 一時表示
      this.context_position = {
        bottom: null,
        top: `${e.clientY}px`,
        left: `${e.pageX}px`
      };
      this.treeContextShow = true

      let menuHeight = 0;
      const _this = this;
      this.$nextTick(function() {
        // メニュー高さ取得（表示してからでないと0となる）
        menuHeight = _this.$refs.contextMenu.clientHeight;
        menuHeight = document.querySelector('#contextMenu').clientHeight;

        // 右クリック位置Y ＋ メニューの高さ > window高さなら
        // クリック位置をbottomとして表示する

        if ((e.clientY + menuHeight) > _this.height) {
          _this.context_position = {
            top: `${e.clientY - menuHeight}px`,
            left: `${e.pageX}px`
          };
        } else {
          _this.context_position = {
            bottom: null,
            top: `${e.clientY}px`,
            left: `${e.pageX}px`
          };
        }
      }.bind(this))
    },
    handlerMenuAddFolder() {
      this.treeContextShow = false
      this.$refs.treeList.handlerMenuAddFolder()
    },
    handlerMenuAddInspect() {
      this.treeContextShow = false
      this.$refs.treeList.handlerMenuAddInspect()
    },
    handlerMenuBackImageSetting() {
      this.treeContextShow = false
      this.$refs.treeList.handlerMenuBackImageSetting()
    },
    handlerAddfile() {
      this.treeContextShow = false
      this.$refs.treeList.handlerAddfile()
    },
    handlerMenuRename() {
      this.treeContextShow = false
      this.$refs.treeList.handlerMenuRename()
    },
    handlerMenuDeleteNode() {
      this.treeContextShow = false
      this.$refs.treeList.handlerMenuDeleteNode()
    },
    /**
     * リサイズのイベントリスナー
     */
     handleResize: function() {
      // windowwのresizeのたびに発生
      this.height = window.innerHeight
    },
  },
};
</script>
